import { Box } from '@mui/material';
import { Outlet } from 'react-router';

export function Highlights() {
  return (
    <Box sx={{ height: 'calc(100vh - 96px)', overflow: 'scroll' }}>
      <title>IR3 | Highlights</title>
      <Outlet />
    </Box>
  );
}
